export default "__VITE_ASSET__RXy8tt9a__"